<template>
  <div class="relative">
    <tooltip ref="tooltip" @hide="$emit('hide')" @show="$emit('show')">
      <template #trigger="{ show, hide }">
        <div class="relative">
          <input
            class="search-input w-full"
            :class="{
              'is-empty': value == '0',
              'cursor-not-allowed': disabled,
            }"
            placeholder="Guests (optional)"
            readonly
            :value="guestsDisplay"
            :disabled="disabled"
            @focus="show"
            @keydown.tab="hide"
            tabindex="2002"
          />

          <svg
            width="20"
            height="20"
            class="search-icon text-black-light-5"
            fill="currentColor"
          >
            <use xlink:href="/img/sprite.svg#ic_people"></use>
          </svg>
        </div>
      </template>

      <template #default>
        <div class="drop-panel">
          <ul class="text-left list-reset">
            <li
              v-for="opt in options"
              :key="opt.value"
              class="select-item cursor-pointer"
              @click="handleSelectGuests(opt.value)"
            >
              {{ opt.label }}
            </li>
          </ul>
        </div>
      </template>
    </tooltip>
  </div>
</template>

<script>
import { getBookingGuestsDisplay } from "../../../helpers";
import { GUESTS, TRAVELERS } from "../../../helpers/constants";
import Tooltip from "../../core/Tooltip";

export default {
  components: {
    Tooltip,
  },
  props: ["value", "disabled", "searchType"],
  computed: {
    options() {
      if (this.searchType === "ecoventure") {
        return TRAVELERS;
      }

      return GUESTS;
    },
    guestsDisplay() {
      const guests = this.value;

      if (guests == "0") {
        if (this.searchType === "ecoventure") {
          return "Guests (optional)";
        }

        return "Guests (optional)";
      }

      const result = getBookingGuestsDisplay(guests);

      if (this.searchType === "ecoventure") {
        return result.replace("guest", "traveler");
      }

      return result;
    },
  },
  methods: {
    handleSelectGuests(numSelected) {
      this.$emit("input", String(numSelected));
      this.$refs.tooltip.hide();
    },
  },
};
</script>

<style scoped>
.search-input {
  border: none;
}

.drop-panel {
  z-index: 10;
}

.is-empty {
  color: var(--black-light-3);
}

.select-item {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  height: 48px;
  line-height: 48px;
}

.select-item:hover {
  background: var(--black-light-1);
}

@media (max-width: 768px) {
  .select-item {
    height: 40px;
    line-height: 40px;
  }
}
</style>
